import type { FC } from 'react';
import React from 'react';

import { findScore, getScores } from '../../helpers';

import {
    DESKTOP_HEIGHT,
    DESKTOP_WIDTH,
    PENTAGRAM_BASE_RADIUS,
    PENTAGRAM_GRID_WIDTH,
    PENTAGRAM_SCORE_TYPE_NAMES,
    PENTAGRAM_SCORES_NUMBER,
    PENTAGRAM_TOTAL_SCORE_TYPE_NAME,
    PENTAGRAM_VIEW_BOX,
} from './constants';
import type { IPentagram } from './models';
import { getScoreStringValue } from './helpers';
import { PentagramGrid } from './pentagram-grid';
import { TotalScore } from './total-score';
import { Scores } from './scores';
import { FilledPolygon } from './filled-polygon';

export const Pentagram: FC<IPentagram> = ({ scores }) => {
    const angle = (2 * Math.PI) / PENTAGRAM_SCORES_NUMBER;
    const pentagramScores = getScores(PENTAGRAM_SCORE_TYPE_NAMES, scores);
    const pentagramTotalScore = findScore(PENTAGRAM_TOTAL_SCORE_TYPE_NAME, scores)?.value || 0;
    const isScoreNotEmpty = pentagramTotalScore !== 0;

    return (
        <svg height={DESKTOP_HEIGHT} viewBox={PENTAGRAM_VIEW_BOX} width={DESKTOP_WIDTH}>
            <g transform="translate(-75, -78.5)">
                <PentagramGrid strokeWidth={PENTAGRAM_GRID_WIDTH} />
            </g>
            {isScoreNotEmpty && (
                <FilledPolygon
                    angle={angle}
                    radius={PENTAGRAM_BASE_RADIUS - PENTAGRAM_GRID_WIDTH * 2}
                    scores={pentagramScores}
                    totalScore={pentagramTotalScore}
                />
            )}
            <Scores angle={angle} radius={PENTAGRAM_BASE_RADIUS} scores={pentagramScores} />
            {isScoreNotEmpty && (
                <TotalScore totalScore={getScoreStringValue(pentagramTotalScore)} />
            )}
        </svg>
    );
};
